import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { useApp } from "@/App";
import CardsMaintenancePage from "@/pages/CardsMaintenancePage";

export default function CardsAccessGate({ children }) {
  const { api, user } = useApp();
  const uid = user?.id;
  const [access, setAccess] = useState(null);
  useEffect(() => {
    let current = true;
    setAccess(null);
    api.get("/cards/access", { timeout: 10000 })
      .then(({ data }) => { if (current) setAccess({ uid, allowed: data?.available === true }); })
      .catch(() => { if (current) setAccess({ uid, allowed: false }); });
    return () => { current = false; };
  }, [api, uid]);
  if (!access || access.uid !== uid) return <section className="flex min-h-[60dvh] items-center justify-center" aria-busy="true" data-testid="cards-access-loading"><Loader2 className="h-5 w-5 animate-spin text-muted-foreground" aria-hidden="true" /></section>;
  return access.allowed ? children : <CardsMaintenancePage />;
}
